<template>
  <Link
    class="block h-full"
    :href="route('frontend.theme-auctions.show', themeAuction.slug)"
  >
    <div class="flex flex-col h-full bg-white rounded overflow-clip">
      <div class="grid grid-cols-2 grid-rows-2">
        <img
          v-for="(image, name) in themeAuction.top_auction_images"
          :key="name"
          :alt="name"
          :src="image"
          class="min-w-full"
        >
      </div>
      <div class="flex flex-col justify-between grow px-3 py-2 border-1 border-top border-gray-500">
        <div class="text-lg md:text-xl mb-2">
          {{ themeAuction.name }}
        </div>
        <time
          class="text-xs text-gray-500 uppercase has-ending-block"
          :class="[themeAuction.end_at_past ? 'timer-has-ended' : 'timer-is-active']"
          :datetime="themeAuction.end_at"
        >
          <div class="active-block">
            {{ themeAuction.end_at }}
          </div>
          <div class="ending-block text-uppercase bg-red-500 text-white pt-1 pb-0.5 px-2 ">
            <span>
              Aan het sluiten
            </span>
          </div>
        </time>
      </div>
      <div class="px-3 pt-3 pb-2 bg-sky-600">
        <div class="font-bold text-center md:text-left text-xl md:text-2xl text-white uppercase">
          Bekijk deze veiling
        </div>
      </div>
    </div>
  </Link>
</template>

<script>
import {Link} from '@inertiajs/vue2';

export default {
  components: {Link},

  props: {
    themeAuction: {
      required: true,
      type: Object,
    },
  },
};
</script>
